import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip"
import { Link, useRouterState } from "@tanstack/react-router"
import { LayoutGrid, Stethoscope, Users } from "lucide-react"
import { useEffect, useState } from "react"

const allItems = [
  { label: "Dashboard", to: "/dashboard", icon: LayoutGrid, roles: ['admin'] },
  { label: "Manager", to: "/manager/", icon: Users, roles: ['admin', 'manager'] },
  { label: "Technician", to: "/technician/", icon: Stethoscope, roles: ['admin', 'manager', 'technician'] },
]

export default function MiniSidebar() {
  const router = useRouterState()
  const path = router.location.pathname
  const [userRole, setUserRole] = useState<string>('admin')
  
  useEffect(() => {
    // Get user role from localStorage
    const userData = localStorage.getItem('user')
    if (userData) {
      try {
        const user = JSON.parse(userData)
        setUserRole(user.role?.toLowerCase() || 'admin')
      } catch (error) {
        console.error('Error parsing user data:', error)
      }
    }
  }, [])
  
  // Filter items based on user role
  const items = allItems.filter(item => item.roles.includes(userRole))
  
  const getActiveIndex = () => {
    // Check if it's a dashboard route
    if (path.startsWith('/dashboard')) {
      return items.findIndex(item => item.to === '/dashboard')
    }
    // Check if it's a manager route
    if (path.startsWith('/manager')) {
      return items.findIndex(item => item.to.startsWith('/manager'))
    }
    // Check if it's a technician route
    if (path.startsWith('/technician')) {
      return items.findIndex(item => item.to.startsWith('/technician'))
    }
    // Default to first item
    return 0
  }
  
  const activeIndex = getActiveIndex()
  
  return (
    <div className="w-12 h-full bg-white border-r flex flex-col items-center py-2 gap-2">
      <TooltipProvider>
        {items.map((item, i) => {
          const Icon = item.icon
          const active = i === activeIndex
          return (
            <Tooltip key={i}>
              <TooltipTrigger asChild>
                <div className="w-full relative flex justify-center">
                  {active ? (
                    <span className="absolute left-0 top-1/2 -translate-y-1/2 h-4 w-[3px] rounded bg-blue-600" aria-hidden="true" />
                  ) : null}
                  <Link
                    to={item.to}
                    className={`h-8 w-8 grid place-items-center rounded-md ${active ? 'bg-blue-50 text-blue-600' : 'text-gray-400 opacity-50 hover:opacity-100 hover:bg-accent hover:text-accent-foreground'}`}
                    preload="intent"
                  >
                    <Icon size={16} />
                  </Link>
                </div>
              </TooltipTrigger>
              <TooltipContent side="right" className="text-xs">
                {item.label}
              </TooltipContent>
            </Tooltip>
          )
        })}
      </TooltipProvider>
    </div>
  )
}